import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"

const App = ({ children }: { children: React.ReactNode }) => {
  return <LocalizationProvider dateAdapter={AdapterMoment}>{children}</LocalizationProvider>
}

export default App
